import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { queryString } from 'components/sharpr/url/builder/urlBuilder.js';
import moment from 'moment';
import _ from 'lodash';

export function EventsSearchRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EventsSearch', {
		url: '/admin/events/search',
		controllerAs: 'vm',
		controller: EventsSearchCtrl,
		templateUrl: '/ng/hub/Events/Search/EventsSearchCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			eventTypes: ApiResourcify.endpoint('/metrics', { cacheFor: 30 * 60 * 60 * 1000 }),
			style: () => AssetManager.css('/ng/hub/Events/Search/EventsSearchCtrl.css'),
			$title: () => 'Recent Events',
		},
	});
}

export class EventsSearchCtrl {
	constructor(Api, Identity, eventTypes) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.Identity = Identity;
		// self binding
		this.suggestUsers = this.suggestUsers.bind(this);
		// setup choices
		this.eventTypes = eventTypes;
		this.accountChoices = this.Identity.accountChoices();
		this.hubChoices = this.Identity.hubChoices();
		this.dateRangeDefault = [moment().add(-30, 'days'), moment().endOf('day')];
		this.filterUsers = [];
		this.sortOptions = [
			{ id: '-created_at', name: 'Sort by date' },
			{ id: 'fname', name: 'Sort by first name' },
			{ id: 'lname', name: 'Sort by last name' },
		];
		// initial data load
		this.clearCriteria();
		this.clearResults();
		this.load();
	}

	suggestUsers(term) {
		return this.Api.get('/users/search', { term }).then(users => {
			const suggestions = [];
			const chosenIds = _.pluck(this.filterUsers, 'id');
			users.forEach(user => {
				if (chosenIds.indexOf(user.id) > -1) {
					// user was already chosen; don't suggest again
					return;
				}
				suggestions.push({
					id: user.id,
					$search: ((user.fname_preferred || user.fname) + ' ' + (user.lname_preferred || user.lname)).trim(),
				});
			});
			return suggestions;
		});
	}

	clearCriteria() {
		this.criteria = this.getDefaultParams();
	}

	getDefaultParams() {
		return {
			event_code: _.pluck(this.eventTypes, 'code'),
			date: this.dateRangeDefault,
			hub_id: _.pluck(this.hubChoices, 'id'),
			account_id: _.pluck(this.accountChoices, 'id'),
			user_id: [],
			limit: 100,
			page: 1,
			sort: '-created_at',
		};
	}

	getUrlParams() {
		const defs = this.getApiParams(this.getDefaultParams());
		const curr = this.getApiParams(this.criteria);
		const nonDefaults = {};
		Object.keys(defs).forEach(field => {
			if (curr[field] != defs[field]) {
				nonDefaults[field] = curr[field];
			}
		});
		return queryString(nonDefaults);
	}

	clearResults() {
		this.events = [];
	}

	getApiParams(input) {
		const start = moment(input.date[0]).startOf('day').format();
		const end = moment(input.date[1]).endOf('day').format();
		return {
			event_code: input.event_code.join(','),
			date: `${start},${end}`,
			hub_id: input.hub_id.join(','),
			account_id: input.account_id.join(',') || undefined,
			user_id: input.user_id.join(','),
			limit: input.limit,
			page: input.page,
			sort: input.sort,
		};
	}

	async load() {
		this.isLoading = true;
		this.hasCriteria = this.getUrlParams().length > 0;
		console.log('urlparams=', this.getUrlParams());
		const events = await this.Api.get('/metrics/events/search', this.getApiParams(this.criteria));
		this.isLoading = false;
		this.events = this.events.concat(events);
	}

	reload() {
		this.clearResults();
		this.load();
	}

	filterByUsers() {
		this.criteria.user_id = _.pluck(this.filterUsers, 'id');
		this.reload();
	}
}
